import { render, staticRenderFns } from "./ScreenRequesterCollection.vue?vue&type=template&id=c570b160&scoped=true"
import script from "./ScreenRequesterCollection.vue?vue&type=script&lang=js"
export * from "./ScreenRequesterCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c570b160",
  null
  
)

export default component.exports